import { hash } from '@ember/helper';
import { service } from '@ember/service';

import CpPanel from 'ember-collapsible-panel/components/cp-panel/component';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview/index';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsLabelComponent extends Component {
  // Services
  @service data;

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-2/3@tablet'>
          <form.fieldset @titleKey='content' as |fieldset|>
            <fieldset.field @property='name' />
            <fieldset.field @property='text' @type='text-editor' />

            <fieldset.field
              @filters={{hash assetFolderId='8'}}
              @property='asset'
              @options={{hash allowedFolder='100'}}
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>
          </form.fieldset>

          <form.sections.seo />
        </div>
        <div class='o-layout__item u-1/1 u-1/3@tablet'>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
            @variantChannelActions={{hash openNewRecord=false openRecord=false}}
          />

          <form.fieldset @titleKey='settings' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}
          </form.fieldset>

          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field
              @property='channels'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='externalReferences'
              @type='has-many'
              @hasManySortable={{true}}
              @on={{hash
                openNewRecord=this.newRecord
                removeRecord=this.deleteRelation
                openRecord=false
                openRecordList=false
              }}
              as |record field|
            >
              <CpPanel @open={{record.isNew}} as |panel|>
                <panel.toggle>
                  {{record.type.name}}
                  |
                  {{record.val}}
                </panel.toggle>
                <panel.body>
                  <Form
                    @model={{record}}
                    @parentModel={{form.model}}
                    @showErrors={{@showErrors}}
                    as |subform|
                  >
                    <subform.field
                      @property='type'
                      @type='select-record'
                      @disabled={{field.isDisabled}}
                      @isSearchEnabled={{true}}
                      @options={{this.data.externalReferenceServices}}
                    />
                    <subform.field
                      @property='val'
                      @disabled={{field.isDisabled}}
                    />
                    <subform.field
                      @property='param'
                      @disabled={{field.isDisabled}}
                    />
                  </Form>
                </panel.body>
              </CpPanel>
            </fieldset.field>
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
